import { IRegisterInvitedUserRequest } from "api/models/request/IRegisterInvitedUserRequest"
import { registerInvitedUser } from "api/services/user-service"
import useApiCall from "./useApiCall"

export const useRegisterInvitedUser = () => {
    const { callAPI, loading } = useApiCall<IRegisterInvitedUserRequest, any>(registerInvitedUser, 'registerInvitedUser.success');

    return { registerInvitedUser: callAPI, registerInvitedUserPending: loading }
}